import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';

import { RadianceThemeProvider } from 'jsx/components/radianceThemeProvider';
import FeatureFlagStore from 'jsx/stores/featureFlagStore';

import InformationRequest from './app';

const featureFlagStore = new FeatureFlagStore();

render(
  <Provider featureFlagStore={featureFlagStore}>
    <RadianceThemeProvider>
      {/* TODO: add an error boundary once it can be used without the userStore */}
      <Router>
        <InformationRequest />
      </Router>
    </RadianceThemeProvider>
  </Provider>,
  document.getElementById('main-content'),
);
